import Axios from 'axios';

const axios = Axios.create();
const secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
const hostname = process.env.VUE_APP_ENDPOINT_SERVICES_PROXY;
const endpoint = "/api/services-new/logger/log";

const info = (message, trace = null) => {
  return log('info', message, trace);
};

const warning = (message, trace = null) => {
  return log('warning', message, trace);
};

const error = (message, trace = null) => {
  return log('error', message, trace);
};

async function log(level, message, trace) {
  return await axios.post(secure + hostname + endpoint, {
    app: process.env.VUE_APP_APP_NAME,
    level: level,
    message: message,
    trace: trace
  });
}

export default {info, warning, error};